import Resource from '@/services/resources/common';

export default class ZoneResource extends Resource {
  constructor(entrypoint = '/zones', alias = 'Zone') {
    super(entrypoint, alias);
  }
}
